export default "__VITE_ASSET__Dfg66W2$__"